import { render, staticRenderFns } from "./ContestList.vue?vue&type=template&id=b433c744&scoped=true"
import script from "./ContestList.vue?vue&type=script&lang=js"
export * from "./ContestList.vue?vue&type=script&lang=js"
import style0 from "./ContestList.vue?vue&type=style&index=0&id=b433c744&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b433c744",
  null
  
)

export default component.exports